// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable-next-line selector-class-pattern */
.react-flow__node-toolbar {
    position: fixed !important;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}

/* stylelint-disable-next-line selector-class-pattern */
.react-flow__node-toolbar * {
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomNodes/NodeToolBarWrapper.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;IACI,0BAA0B;IAC1B,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;AACrB;;AAEA,uDAAuD;AACvD;IACI,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;AACrB","sourcesContent":["/* stylelint-disable-next-line selector-class-pattern */\n.react-flow__node-toolbar {\n    position: fixed !important;\n    user-select: none;\n}\n\n/* stylelint-disable-next-line selector-class-pattern */\n.react-flow__node-toolbar * {\n    user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
